<template>
  <div class="culture">
     <div class="aa" @click="aa()">
    </div>

      <!-- 设备列表 -->
      <div v-if="indexs">
          <div class="col-md-4" v-for="(item,index) in productList">
            <div class="border-con" @click="equipmentDetail(item,item.id)">
              <img v-bind:src="item.location" alt="">
              <div class="text">
                 <h5>{{item.title}}</h5>
                 <p class="texts" v-html="item.describe">

                 </p>
              </div>
            </div>
          </div>
     
      </div>
      
      <!-- 设备列表详情 -->
      <div v-if="indexs==false">
         <equipment-detail v-bind:id.sync='id'></equipment-detail>
      </div>
  </div>
</template>

<script>
import equipmentDetail from '../detail/equipmentDetail.vue'
export default {
  name: 'Culture',
  props:['indexs'],
  data () {
    return {
      Index:1,
      productList:[],
      id:0,
    }
  },
  created(){
      this.getProductList();
  },
  watch:{
    indexs(newValue,oldValue){
      this.indexs=newValue;
      console.log(oldValue)
    }
  },
  components:{
    'equipmentDetail':equipmentDetail
  },

  methods:{
    aa () {
      this.indexs = true;
    },
   equipmentDetail (index,id) {
      this.indexs = false;
      this.Index = index;
      this.id=id;
   },
   getProductList () {
      let self = this;
      const req = {
        index:1,
        size:10
      }
      this.$http.post('product/pageSelect/'+req.index+'/'+req.size,{}).then((data)=>{
        if(data.body.success){
            for(var i in data.body.data){
              self.productList.push(data.body.data[i])
            }
        }
      })
   }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.texts {
    position:relative;
    line-height:1.4em;
    /* 3 times the line-height to show 3 lines */
    height:4.2em;
    overflow:hidden;
    padding-left: 8px;
    padding-right: 8px;
}
.texts::after {
    content:"";
    font-weight:bold;
    position:absolute;
    bottom:0;
    right:0;
    padding:0 20px 1px 45px;
    background:url(http://newimg88.b0.upaiyun.com/newimg88/2014/09/ellipsis_bg.png) repeat-y;
}
.culture img{
  width: 100%;
}
.culture .col-md-4{
  margin-bottom: 10px;
  padding: 2px;
}
.text h5,p{
  margin: 6px;
  padding: 0;
  text-align: left;
  padding-left: 8px;
  padding-right: 6px
}
 .text h5{
  margin-top: 18px;
  margin-bottom: 10px;
}
.text p{
  font-size: 12px;
  text-align: left;
  color:#9A9A9A;
  line-height: 24px;
}
.border-con{
  background: #ffffff;
  width: 94%;
  margin-bottom: 4px;
  box-shadow: 0 0 10px 2px rgba(0,0,0,.1);
  padding: 0 0 10px 0;
}
  .aa{
    width: 255px;
    height: 40px;
    background-color: red;
    position: absolute;
    left: -270px;
    top: -55px;
    opacity:0;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/commerceEquipment.vue